function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M33.941 11.314a16 16 0 100 22.627 16.018 16.018 0 000-22.627zM16.628 24.62a1 1 0 01-1-1v-1.997a1 1 0 011-1c.02.009 8.022-.039 12-.003a1 1 0 011 1v2a1 1 0 01-1 1z"
});

function SvgIconMinusBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45.255 45.255"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NS4yNTUgNDUuMjU1Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDojMDAwO308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iYSIgZD0iTTIxMC4yMzIsMTkxLjQ0OGExNiwxNiwwLDEsMCwxNiwxNkExNi4wMTgsMTYuMDE4LDAsMCwwLDIxMC4yMzIsMTkxLjQ0OFpNMjA3LjQsMjEzLjFhMSwxLDAsMCwxLTEuNDE0LDBsLTEuNDEzLTEuNDEyYTEsMSwwLDAsMSwwLTEuNDE0Yy4wMi0uMDA4LDUuNjQ1LTUuNyw4LjQ4NC04LjQ4OGExLDEsMCwwLDEsMS40MTQsMGwxLjQxNCwxLjQxNWExLDEsMCwwLDEsMCwxLjQxNFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwLjY1OSAtMjcyLjcxNykgcm90YXRlKDQ1KSIvPjwvc3ZnPgo=";
export { SvgIconMinusBlack as ReactComponent };